export default __webpack_public_path__ + "static/media/logo_defender_club.d8807bf2.svg";